import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { brandsQuery, meQuery } from '../lib/queries.js';

// Layout route for /brand/$slug/campaigns.
//
// The index page (the trigger grid + list) lives in
// brand.$slug.campaigns.index.tsx. Sub-routes like
// /campaigns/new/brief, /campaigns/new/drafting/$id, /campaigns/import,
// etc. need this layout's <Outlet/> to render — without it, TanStack
// matches them as nested under /campaigns but the parent has nowhere
// to slot child content and the deeper URL silently re-renders this
// layout. We keep the layout itself bare: each child does its own
// chrome (TopNav, headers) and re-checks auth + brand resolution.

export const Route = createFileRoute('/brand/$slug/campaigns')({
  beforeLoad: async ({ params, context: { queryClient } }) => {
    const me = await queryClient.ensureQueryData(meQuery());
    if (!me) throw redirect({ to: '/login' });
    const brands = await queryClient.ensureQueryData(brandsQuery());
    const brand = brands.find((b) => b.slug === params.slug);
    if (!brand) throw redirect({ to: '/brands' });
    return { me, brand };
  },
  component: () => <Outlet />,
});
